/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ServerSideTableFooter from 'components/common/advance-table/ServerSideTableFooter';
import ServerSideTable from 'components/common/advance-table/ServerSideTable';
import ServerSideTableWrapper from 'components/common/advance-table/ServerSideTableWrapper';
import { getDiseaseList, getinfectionReport, getPestList } from 'api/infection';
import Select from 'react-select';
import { Col } from 'react-bootstrap';

const TableComponent = ({
  data,
  total,
  cursor,
  limit,
  onPageChange,
  onEdit,
  onDelete,
  loading,
  showFilter,
  setExportData,
  onSearch,
  setPageLimit
}) => {
  const [tableData, setTableData] = useState(null);
  const [filteredTableData, setFilteredTableData] = useState(null); // Data to display
  const [pageSize, setPageSize] = useState(limit);
  const [pageIndex, setPageIndex] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [canNextPage, setCanNextPage] = useState(true);
  const [filters, setFilters] = useState({});
  const [globalfilters, setGlobalFilters] = useState({
    search_text: ''
  });

  const flattenedData = data;

  const columns =
    flattenedData?.length > 0
      ? [
          ...Object.keys(flattenedData[0])
            .filter(
              key =>
                !key.includes('_color') &&
                key !== 'farm_id' &&
                key !== 'id' &&
                key != 'more'
            )
            .map((key, index) => ({
              Header: key
                .replace(/_/g, ' ')
                .replace(/(^\w|\b\w(?![^()]*\)))/g, c => c.toUpperCase()),
              accessor: key,
              Cell: ({ value, row }) => {
                // Dynamically handle NA or null values
                const colorKey = `${key}_color`;
                let displayValue =
                  typeof value === 'object' && value !== null
                    ? ' - '
                    : value === 'NA' || value === null
                    ? ' - '
                    : value;

                return (
                  <span style={{ color: row.original[colorKey] || 'inherit' }}>
                    {displayValue || ''}
                  </span>
                );
              }
            }))
        ]
      : [];

  const handlePageChange = newPageIndex => {
    onPageChange(newPageIndex);
    setPageIndex(newPageIndex);
  };

  const handlePageSizeChange = newPageSize => {
    setPageSize(newPageSize);
    setPageLimit({ limit: newPageSize });
    setPageIndex(0);
    setTableData(null);
  };

  // Handle filter changes for specific columns
  const handleFilterChange = (columnId, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [columnId]: value
    }));
  };

  useEffect(() => {
    const lastPageIndex = Math.ceil(total / pageSize) - 1; // Total number of pages
    setCanNextPage(pageIndex < lastPageIndex); // Check if the current page is the last page
  }, [total, pageSize, pageIndex]);

  useEffect(() => {
    // Handle case when filters is undefined or null
    if (!tableData || Object.keys(filters ?? {}).length === 0) {
      setFilteredTableData(tableData); // Reset to original if no filters
      return;
    }

    const filtered = tableData.filter(row =>
      Object.entries(filters).every(([columnId, filterValue]) => {
        const filterValueLower = filterValue.toLowerCase();
        // Check if the value is an array (like weather_parameters, risk_ranges)
        if (Array.isArray(row[columnId])) {
          // For array fields, check if any element in the array contains the filter value
          return row[columnId].some(item =>
            item.toLowerCase().includes(filterValueLower)
          );
        }
        // Otherwise, handle non-array fields (strings, numbers, etc.)
        const cellValue = row[columnId]?.toString().toLowerCase() || '';
        return cellValue.startsWith(filterValueLower);
      })
    );

    setExportData(filtered);
    setFilteredTableData(filtered);
  }, [filters]);

  const customStyles = {
    control: provided => ({
      ...provided,
      // overflowY: 'scroll',
      // whiteSpace: 'nowrap',
      // textOverflow: 'ellipsis',
      // height: '40px',
      minHeight: '80px'
      // backgroundColor: 'blue'
    }),
    valueContainer: provided => ({
      ...provided,
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      textOverflow: 'ellipsis',
      // maxWidth: 'calc(100% - 8px)',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      maxWidth: '200px',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      // background: 'red',
      maxHeight: '90px'
    }),

    multiValue: provided => ({
      ...provided,
      // display: 'none',
      backgroundColor: 'yellow',
      height: 'fit-content'
    }),
    multiValueLabel: provided => ({
      ...provided
      // display: 'none'
      // backgroundColor: 'green',
      // height: '20px'
    })
  };

  // Handle actions like Edit and Delete
  const handleAction = (action, rowData) => {
    // console.log(action, 'action', rowData);
    if (action === 'edit') {
      onEdit(action, rowData); // Trigger onEdit passed as prop
    } else if (action === 'delete') {
      onDelete(rowData); // Trigger onDelete passed as prop
    }
  };

  return (
    <ServerSideTableWrapper
      key={`${pageSize}-${pageIndex}`}
      columns={columns}
      data={filteredTableData || flattenedData}
      pagination
      sortable
      perPage={pageSize}
      className="min-vh-50 py-5"
      stickyColumns={[]}
    >
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <input
          type="text"
          placeholder="Search..."
          className="form-control mb-3 mb-md-0 w-100 w-md-25"
          onChange={e => onSearch(e.target.value)}
        />
        <div className="d-flex flex-column flex-md-row gap-3 w-100 w-md-auto"></div>
      </div>

      {/* {getFarmTableDataAPI.loading && !showFilter ? (
        <CustomSpinner />
      ) : ( */}
      <ServerSideTable
        key={`${pageSize}-${pageIndex}`}
        table
        headerClassName="bg-200 text-900 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0'
        }}
        filters={filters}
        handleFilterChange={handleFilterChange}
        showFilterRow={showFilter}
        pageIndex={pageIndex}
        pageSize={pageSize}
        cursor={cursor}
        clientSideSearch={true}
        handleAction={handleAction}
      />
      {/* )} */}
      <div className="mt-3">
        <ServerSideTableFooter
          rowCount={total}
          pageSize={pageSize}
          pageIndex={pageIndex}
          setPageSize={handlePageSizeChange}
          canPreviousPage={pageIndex > 0}
          canNextPage={canNextPage}
          nextPage={() => handlePageChange(pageIndex + 1)}
          previousPage={() => handlePageChange(Math.max(0, pageIndex - 1))}
          rowsPerPageSelection
          navButtons
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          rowsPerPageOptions={[10, 50, 100, 200]}
          handleFilterChange={handleFilterChange}
        />
      </div>
    </ServerSideTableWrapper>
  );
};

TableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  deletePorjectAPI: PropTypes.object.isRequired,
  startProcessingAPI: PropTypes.object.isRequired
};

ServerSideTableWrapper.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string,
      Header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      Cell: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          value: PropTypes.func.isRequired,
          row: PropTypes.shape({
            original: PropTypes.object.isRequired
          }).isRequired
        })
      ])
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  pagination: PropTypes.bool,
  perPage: PropTypes.number
};

export default TableComponent;
